import { createAction } from 'redux-actions';

import { CLEAR_MONITORING_QUEUE_ENTRIES } from '../types';

export const clearMonitoringQueueEntries = createAction(CLEAR_MONITORING_QUEUE_ENTRIES);


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/actions/clearMonitoringQueueEntriesActions.js